import { useEffect, useRef, useState } from 'react'
import StoreHeaderIcon from 'src/components/icons/store/StoreHeaderIcon'
import { GoogleMapsProvider } from 'src/contexts/google-maps-context'
import { useStoreContext } from 'src/contexts/store-context'
import { useOnClickAway } from 'src/sdk/ui/useOnClickAway'
import {
  black_friday_picking,
  fast_picking,
} from '../../../../../../store.config'
import FavouriteStoreModal from './FavouriteStoreModal'
import StorePickerSidebar from './StorePickerSidebar'
import { getStoreName, useSlidingAnimation } from './utils/utils'

export const Store = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isSidebar, setIsSidebar] = useState(false)
  const modalRef = useRef(null)
  const { favouriteStore, showStoreData } = useStoreContext()
  const { shouldRender } = useSlidingAnimation(isSidebar)

  const pickingTime = black_friday_picking ?? fast_picking

  const closeModal = () => {
    setIsOpen(false)
  }
  const openSidebar = () => {
    setIsSidebar(true)
    setIsOpen(false)
  }
  useOnClickAway({ isOpened: isOpen, ref: modalRef, callback: closeModal })

  useEffect(() => {
    return () => {
      setIsSidebar(false)
    }
  }, [])

  return (
    <>
      <div
        ref={modalRef}
        className={`flex flex-row items-center gap-2 font-light store-locator-container-js ${
          isOpen ? 'open' : ''
        }`}
      >
        {/* {person?.id ? ( */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="flex flex-row items-center gap-1 p-0 store-locator-toggle-js text-black bg-transparent border-none outline-none cursor-pointer"
        >
          <StoreHeaderIcon aria-hidden className="shrink-0" />{' '}
          <span className="block text-sm tracking-[0.15px] !leading-[130%] font-bold underline">
            Il tuo negozio:
          </span>
        </button>
        {/* ) : (
          <a
            href={`${loginUrl}?returnUrl=/account`}
            className="flex flex-row items-center gap-1 p-0 store-locator-toggle-js text-black cursor-pointer"
          >
            <StoreHeaderIcon className="shrink-0" />{' '}
            <span className="block text-sm tracking-[0.15px] !leading-[130%] font-bold underline">
              Il tuo negozio:
            </span>
          </a>
        )} */}

        {
          showStoreData ? (
            <span className="block text-xs leading-[130%] tracking-[0.15px] whitespace-nowrap text-ellipsis font-normal">
              {favouriteStore?.id
                ? getStoreName(favouriteStore)
                : '(nessun negozio selezionato)'}
            </span>
          ) : (
            // person?.id ? (
            <div className="animate-pulse w-48">
              <div className="h-5 bg-gray-500 rounded"></div>
            </div>
          )
          // ) : (
          //   <span className="block text-xs leading-[130%] tracking-[0.15px] whitespace-nowrap text-ellipsis font-normal">
          //     (nessun negozio selezionato)
          //   </span>
          // )
        }

        <FavouriteStoreModal
          favouriteStore={favouriteStore}
          closeModal={closeModal}
          openSidebar={openSidebar}
          pickingTime={pickingTime}
        />
      </div>

      <GoogleMapsProvider>
        {shouldRender && (
          // createPortal(
          <StorePickerSidebar
            isSidebar={isSidebar}
            setIsSidebar={setIsSidebar}
          />
          //   document?.body
        )}
      </GoogleMapsProvider>
    </>
  )
}
